import React, { useEffect, useState, useCallback } from 'react';
import { useMounted } from '@app/hooks/useMounted';
import { Card } from '@app/components/common/Card/Card';
import { Button } from '@app/components/common/buttons/Button/Button';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { useTranslation } from 'react-i18next';
import { getMailerConfig, MailerSettingData, updateMailerConfig } from '@app/api/settings.api';
import { Skeleton } from '@app/components/common/Skeleton/Skeleton';
import { InputNumber } from '@app/components/common/inputs/InputNumber/InputNumber';

const SettingPage: React.FC = () => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { isMounted } = useMounted();

  const fetch = useCallback(() => {
    setLoading(true);
    getMailerConfig()
      .then((data) => {
        form.setFieldsValue(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleSubmit = (values: MailerSettingData) => {
    setLoading(true);
    updateMailerConfig(values).finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <Card padding="1rem 3rem" title="Mailer Settings">
        <Skeleton loading={loading}>
          <BaseForm form={form} layout="vertical" name="mail-setting" style={{ maxWidth: 600 }} onFinish={handleSubmit}>
            <BaseForm.Item name="host" label="SMTP" rules={[{ required: true, message: t('common.requiredField') }]}>
              <Input />
            </BaseForm.Item>
            <BaseForm.Item name="port" label="Port" rules={[{ required: true, message: t('common.requiredField') }]}>
              <InputNumber style={{ width: '100%' }} />
            </BaseForm.Item>
            <BaseForm.Item
              name="username"
              label="Username"
              rules={[{ required: true, message: t('common.requiredField') }]}
            >
              <Input />
            </BaseForm.Item>
            <BaseForm.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: t('common.requiredField') }]}
            >
              <Input />
            </BaseForm.Item>
            <Button type="primary" style={{ marginTop: '15px', float: 'right' }} htmlType="submit">
              Save
            </Button>
          </BaseForm>
        </Skeleton>
      </Card>
    </>
  );
};

export default SettingPage;
